import { Component, ViewChild } from '@angular/core';
import { SelectableStudentListModalComponent } from "../../../../components/personnel-component/student-components/selectable-student-list-modal/selectable-student-list-modal.component";
import { PickerComponent } from '@ctrl/ngx-emoji-mart';
import { QuillModule } from 'ngx-quill';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HelperServiceService } from '../../../../utils/helper-service.service';
import { debounce } from 'lodash';
import { CommonStaffApiServiceService } from '../../../personnel/common-staff-api-service.service';
import { Store } from '@ngrx/store';
import { selectUserId } from '../../../../auth/store/auth.selector';
import { CommunicationApiService } from '../../communication-api.service';
import { ToasterService } from '../../../../providers/toaster/toaster.service';
import { emojis } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { ActivatedRoute } from '@angular/router';
import { StudentApiServiceService } from '../../../personnel/student/student-api-service.service';
@Component({
  selector: 'app-create-message',
  standalone: true,
  imports: [PickerComponent, QuillModule, ReactiveFormsModule, FormsModule],
  templateUrl: './create-message.component.html',
  styleUrl: './create-message.component.css'
})
export class CreateMessageComponent {

  isRecipientModalOpen = false
  minDate = new Date().getDate();
  userSearch: string = ''
  messageForm!: FormGroup
  time: any[] = []
  userId: any
  users: any[] = []
  selectedUsers: any[] = []
  groupId: any
  classId: any

  communicationId: any
  communicationData: any

  constructor(private fb: FormBuilder, private helperService: HelperServiceService, private commonStaffApiService: StudentApiServiceService, private store: Store, private communicationApiService: CommunicationApiService,
    private toaster: ToasterService, private activeRoute: ActivatedRoute
  ) {
    store.select(selectUserId).subscribe((res) => {
      this.userId = res
    })

    this.activeRoute.params.subscribe((params) => {
      this.communicationId = params['id']
    })
    this.activeRoute.queryParams.subscribe((params) => {
      this.groupId = params['group_id'] ?? params['groupId'] ?? params['group'];
      this.classId = params['class_id'] ?? params['classId'] ?? params['class'];
    })

    if (this.communicationId) {
      this.getData(this.communicationId)
    }

  }

  ngOnInit() {
    this.messageForm = this.fb.group({
      communication_type: ['email'],
      message: [''],
      topic: [''],
      user_ids: this.fb.array([]),
      attachments: this.fb.array([]),
      schedule_date: [''],
      schedule_time: [''],
      owner_id: [this.userId]
    })
    this.time = this.helperService.TimeOptions()
    this.commonStaffApiService.getStudentList().subscribe({
      next: (res: any) => {
        this.users = res.data
      }
    })
    if (!this.communicationId) {
      if (this.groupId) {
        this.preselectGroupStudents(this.groupId);
      } else if (this.classId) {
        this.preselectClassStudents(this.classId);
      }
    }
  }


  getData(id: any) {
    this.communicationApiService.getMessage(id).subscribe({
      next: (res: any) => {
        this.communicationData = res.data
        this.messageForm.patchValue(this.communicationData)
        const userIds = this.messageForm.get('user_ids') as FormArray;
        this.communicationData.user_ids.forEach((userId: any) => {
          userIds.push(this.fb.control(userId));
        });
        this.selectedUsers = this.users.filter((user: any) => this.communicationData.user_ids.includes(user.id)) || [];        
      }
    })
  }

  onSubmit(isSend?: boolean) {
    const data = this.messageForm.value
    data.is_instant = isSend ? 1 : 0
    if (this.communicationId) {
      this.communicationApiService.updateMessage(data, this.communicationId).subscribe({
        next: (res: any) => {
          if (res.status == 'success') {
            this.toaster.setToaster('success', 'Success', res.message || 'Successfully sent' + this.messageForm.get('communication_type')?.value);
            window.history.back();
          } else {
            this.toaster.setToaster('error', 'Error', res.message || 'Something went wrong');
          }
        },
        error: (err: any) => {
          console.log(err)
        }
      })
    } else {
      this.communicationApiService.storeMessage(data).subscribe({
        next: (res: any) => {
          if (res.status == 'success') {
            this.toaster.setToaster('success', 'Success', res.message || 'Successfully sent' + this.messageForm.get('communication_type')?.value);
            window.history.back();
          } else {
            this.toaster.setToaster('error', 'Error', res.message || 'Something went wrong');
          }
        },
        error: (err: any) => {
          console.log(err)
        }
      })
    }

  }


  onUserSearch = debounce((e?: any) => {
    const str = e.target.value
    this.commonStaffApiService.getStudentSearch({ search: str }).subscribe({
      next: (res: any) => {
        this.users = res.data || []
      }
    })
    return;
  }, 500);


  onSelectUser(i: any) {
    this.selectedUsers.push(this.normalizeUser(i))
    const users = this.messageForm.get('user_ids') as FormArray
    users.push(this.fb.control(i.id))
  }
  removeUser(i: any) {
    this.selectedUsers.splice(i, 1)
    const users = this.messageForm.get('user_ids') as FormArray
    users.removeAt(i)
  }

  isUserSelected(id: any) {
    return this.selectedUsers.some((i: any) => i.id === id)
  }

  private preselectGroupStudents(groupId: any) {
    this.commonStaffApiService.getStudentbyGroup(groupId).subscribe({
      next: (res: any) => {
        const students = Array.isArray(res?.data?.students) ? res.data?.students : [];
        this.setSelectedUsers(students);
      },
      error: (err: any) => {
        console.log(err);
      }
    });
  }

  private preselectClassStudents(classId: any) {
    this.commonStaffApiService.getStudentbyClass(classId).subscribe({
      next: (res: any) => {
        const students = Array.isArray(res?.data) ? res.data : [];
        this.setSelectedUsers(students);
      },
      error: (err: any) => {
        console.log(err);
      }
    });
  }

  private setSelectedUsers(users: any[]) {
    const userIds = this.messageForm.get('user_ids') as FormArray;
    while (userIds.length) {
      userIds.removeAt(0);
    }
    const normalized = users.map((u) => this.normalizeUser(u));
    const unique = new Map<number | string, any>();
    normalized.forEach((u) => {
      if (!unique.has(u.id)) {
        unique.set(u.id, u);
      }
    });
    this.selectedUsers = Array.from(unique.values());
    this.selectedUsers.forEach((u) => userIds.push(this.fb.control(u.id)));
  }

  private normalizeUser(user: any) {
    if (!user) {
      return user;
    }
    const builtName = [user.first_name, user.last_name].filter(Boolean).join(' ');
    const name = user.name || user.full_name || builtName;
    return {
      ...user,
      name: name || user.name
    };
  }

  addEmoji(event: any) {
    this.messageForm.get('topic')?.setValue(this.messageForm.get('topic')?.value + event.emoji.native);
  }

  onEditorChange(event: any) {
    const content = event.text; // or event.html
    this.messageForm.get('message')?.setValue(content);
  }

}
